import clsx from 'clsx';
import {FieldError} from 'react-hook-form';

type FormErrorPropsT = {
  error: FieldError | undefined;
  className?: string;
};

function FormError({error, className}: FormErrorPropsT) {
  return (
    error && (
      <div className={clsx('flex items-center pt-2', className)}>
        <div className="ti ti-alert-triangle text-red"></div>
        <div className="form-error pl-1">{error.message}</div>
      </div>
    )
  );
}

export default FormError;
